export default {
  wrapper: {
    '& .MuiPaper-root': {
      backgroundColor: (theme) => theme.palette.grays.lightestGray,
    },
  },
  section: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '24px',
    marginBottom: '16px',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: (theme) => theme.palette.grays.gray700,
    fontSize: '1.25rem',
    fontWeight: 700,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
  },
};
